import Vue from 'vue'
import Vuex from 'vuex'
import {
    ElementApiModule,
    SyncsWithUrl,
    ContinuousCollectionComponent,
    ResetsPage
} from 'clockvine-vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import PostCard from './components/PostCard.vue'

gsap.registerPlugin(ScrollTrigger)
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        blog: new ElementApiModule('blog.json', { debounce: 1000 }),
    },
})

new Vue({ // eslint-disable-line no-new
    store,
    el: '#blogListing',
    components: {
        blog: ContinuousCollectionComponent.for('blog'),
        PostCard,
    },
    mixins: [
        new SyncsWithUrl('params'),
        new ResetsPage(),
    ],
    data: {
        focusIndex: 0,
        params: {
            page: 1,
            search: null,
        },
    },
    methods: {
        handleLoadMore () {
            this.focusIndex = this.$refs.articleList.childElementCount
            this.params.page++
        },
        handleLoadFinish (payload) {
            if (!payload && this.focusIndex > 0) {
                this.$refs.articleList.querySelector(`.postCard:nth-of-type(${this.focusIndex}) .postCard__heading a`).focus()
            }
        },
    },
})
